export const URL_PROJECT = process.env.API_ROOT + "/catering-operation-server";

const url = {
  /** URL-获取token */
  TOKEN: '/token.action',
  /** URL-登录 */
  LOGIN: '/login.action',
  /** URL-退出 */
  LOGOUT: '/logout.action',
  /** URL-获取图形验证码 */
  VERIFY_CODE: URL_PROJECT+"/acquireImageValidateCode.action",
  /** URL-统一验证接口 */
  VALID: "/valid.action",
  /** URL-修改密码 */
  MODIFY_PASSWORD: "/modifyPassword.action",

  //unit
  /** URL-获取单位列表 */
  LIST_MATERIAL_UNIT: "/unit/listMaterialUnit.action",
  /** URL-添加单位 */
  ADD_MATERIAL_UNIT: "/unit/addMaterialUnit.action",
  /** URL-删除单位 */
  REMOVE_MATERIAL_UNIT: "/unit/removeMaterialUnit.action",

  //log
  /** URL-日志管理 */
  LOG_PAGE_BY_FUZZY: "/log/pageByFuzzy.action",

  //materialType
  /** URL-获取分类列表 */
  LIST_MATERIAL_TYPE: "/materialType/listMaterialType.action",
  /** URL-添加分类 */
  ADD_MATERIAL_TYPE: "/materialType/addMaterialType.action",
  /** URL-删除分类 */
  REMOVE_MATERIAL_TYPE: "/materialType/removeMaterialType.action",

  //shop
  /** URL-搜索门店（分页） */
  LIST_SHOP: "/shop/listShop.action",
  /** URL-添加门店 */
  ADD_SHOP: "/shop/addShop.action",
  /** URL-停用门店 */
  STOP_SHOP: "/shop/stopShop.action",
  /** URL-获取门店详情 */
  ACQUIRE_SHOP_DETAIL: "/shop/acquireShopDetail.action",
  /** URL-修改门店 */
  MODIFY_SHOP: "/shop/modifyShop.action",
  /** URL-添加供应商 */
  ADD_SUPPLIER_SHOP: "/shop/addSupplier.action",
  /** URL-分页获取供应商列表 */
  LIST_SUPPLIER_SHOP: "/shop/listSupplier.action",
  /** URL-删除供应商 */
  DELETE_SUPPLIER_SHOP: "/shop/deleteSupplier.action",
  /** URL-添加采购货品 */
  ADD_PURCHASE_MATERIAL_SHOP: "/shop/addPurchaseMaterial.action",
  /** URL-修改采购货品 */
  MODIFY_PURCHASE_MATERIAL_SHOP: "/shop/modifyPurchaseMaterial.action",
  /** URL-删除货品（采购、要货） */
  DELETE_MATERIAL_SHOP: "/shop/deleteMaterial.action",
  /** URL-添加要货货品 */
  ADD_REQUIRE_MATERIAL_SHOP: "/shop/addRequireMaterial.action",
  /** URL-分页获取采购货品列表 */
  LIST_PURCHASE_MATERIAL_SHOP: "/shop/listPurchaseMaterial.action",
  /** URL-分页获取要货货品列表 */
  LIST_REQUIRE_MATERIAL_SHOP: "/shop/listRequireMaterial.action",
  /** URL-批量添加采购货品 */
  BATCH_ADD_PURCHASE_MATERIAL: "/shop/batchAddPurchaseMaterial.action",
  /** URL-门店-采购品 */
  SHOP_EXPORT_PURCHASE_MATERIAL: "/shop/exportPurchaseMaterial.action",
  /** URL-门店-要货品 */
  EXPORT_REQUIRE_MATERIAL: "/shop/exportRequireMaterial.action",

  //distributionCenter
  /** URL-搜索配送中心（分页） */
  LIST_DISTRIBUTION_CENTER: "/distributionCenter/listDistributionCenter.action",
  /** URL-删除配送中心 */
  DELETE_DISTRIBUTION_CENTER: "/distributionCenter/delete.action",
  /** URL-启用/停用配送中心 */
  STOP_DISTRIBUTION_CENTER: "/distributionCenter/stop.action",
  /** URL-添加配送中心 */
  ADD_DISTRIBUTION_CENTER: "/distributionCenter/add.action",
  /** URL-修改配送中心 */
  MODIFY_DISTRIBUTION_CENTER: "/distributionCenter/modify.action",
  /** URL-获取配送中心详情 */
  ACQUIRE_DISTRIBUTION_CENTER: "/distributionCenter/acquire.action",
  /** URL-分页获取门店列表 */
  LIST_SHOP_DISTRIBUTION_CENTER: "/distributionCenter/listShop.action",
  /** URL-分页获取供应商列表 */
  LIST_SUPPLIER: "/distributionCenter/listSupplier.action",
  /** URL-获取中央厨房 */
  ACQUIRE_KITCHEN: "/distributionCenter/acquireKitchen.action",
  /** URL-添加门店 */
  ADD_SHOP_DISTRIBUTION_CENTER: "/distributionCenter/addShop.action",
  /** URL-删除门店 */
  DELETE_SHOP: "/distributionCenter/deleteShop.action",
  /** URL-添加供应商 */
  ADD_SUPPLIER: "/distributionCenter/addSupplier.action",
  /** URL-删除供应商 */
  DELETE_SUPPLIER: "/distributionCenter/deleteSupplier.action",
  /** URL-修改中央厨房 */
  MODIFY_KITCHEN: "/distributionCenter/modifyKitchen.action",
  /** URL-添加采购货品 */
  ADD_PURCHASE_MATERIAL: "/distributionCenter/addPurchaseMaterial.action",
  /** URL-修改采购货品 */
  MODIFY_PURCHASE_MATERIAL: "/distributionCenter/modifyPurchaseMaterial.action",
  /** URL-删除货品（采购、产成品） */
  DELETE_MATERIAL: "/distributionCenter/deleteMaterial.action",
  /** URL-添加产成品 */
  ADD_PRODUCE_MATERIAL: "/distributionCenter/addProduceMaterial.action",
  /** URL-查询配送中心的货品（要货 && 调拨 添加货品 搜索接口） */
  SEARCH_MATERIAL_DISTRIBUTION: "/distributionCenter/searchMaterial.action",
  /** URL-添加要货货品 */
  ADD_REQUIRE_MATERIAL: "/distributionCenter/addRequireMaterial.action",
  /** URL-添加调拨货品 */
  ADD_ALLOT_MATERIAL: "/distributionCenter/addAllotMaterial.action",
  /** URL-删除调拨货品 */
  DELETE_ALLOT_MATERIAL: "/distributionCenter/deleteAllotMaterial.action",
  /** URL-删除要货货品 */
  DELETE_REQUIRE_MATERIAL: "/distributionCenter/deleteRequireMaterial.action",
  /** URL-分页获取采购货品列表 */
  LIST_PURCHASE_MATERIAL: "/distributionCenter/listPurchaseMaterial.action",
  /** URL-分页获取生产货品列表 */
  LIST_PRODUCE_MATERIAL_DISTRIBUTION: "/distributionCenter/listProduceMaterial.action",
  /** URL-分页获取调拨货品列表 */
  LIST_ALLOT_MATERIAL: "/distributionCenter/listAllotMaterial.action",
  /** URL-分页获取要货货品列表 */
  LIST_REQUIRE_MATERIAL: "/distributionCenter/listRequireMaterial.action",
  /** URL-获取配送单价 */
  ACQUIRE_DEFAULT_PRICE: "/distributionCenter/acquireDefaultPrice.action",
  /** URL-导出产成品 */
  EXPORT_PRODUCE_MATERIAL: "/distributionCenter/exportProduceMaterial.action",
  /** URL-导出采购货品 */
  EXPORT_PURCHASE_MATERIAL: "/distributionCenter/exportPurchaseMaterial.action",

  //common
  /** URL-门店搜索（最多10条） */
  SEARCH_SHOP: "/common/searchShop.action",
  /** URL-配送中心搜索（最多10条） */
  LIST_DISTRIBUTION_CENTER_COMMON: "/common/listDistributionCenter.action",
  /** URL-搜索货品（最多10条） */
  SEARCH_MATERIAL: "/common/searchMaterial.action",
  /** URL-搜索产成品货品（最多10条） */
  SEARCH_PRODUCE_MATERIAL: "/common/searchProduceMaterial.action",
  /** URL-供应商搜索 */
  SEARCH_SUPPLIER: "/common/searchSupplier.action",
  /** URL-根据货品id获取供应商列表 */
  LIST_SUPPLIER_BY_MATERIAL: "/common/listSupplierByMaterial.action",
  /** URL-中央厨房列表 */
  LIST_KITCHENS_COMMON: "/common/listKitchen.action",
  /** URL-根据供应商id获取物料 */
  LIST_MATERIAL_BY_SUPPLIER: "/common/listMaterialBySupplier.action",
  /** URL-制单人列表 */
  LIST_STAFF_COMMON: "/common/listStaff.action",
  /** URL-获取门店列表 */
  LIST_SHOP_COMMON: "/common/listShop.action",
  /** URL-获取商户列表 */
  LIST_MERCHANT_COMMON: "/common/listMerchant.action",

  //bom
  /** URL-搜索产成品列表 */
  LIST_PRODUCE_MATERIAL: "/bom/listProduceMaterial.action",
  /** URL-搜索产成品的配方列表 */
  LIST_BOM: "/bom/listBom.action",
  /** URL-搜索配方的原材料列表 */
  LIST_BOM_ITEMS: "/bom/listBomItems.action",
  /** URL-添加配方 */
  ADD_BOM: "/bom/addBom.action",
  /** URL-添加配方原材料 */
  ADD_BOM_DETAIL: "/bom/addBomDetail.action",
  /** URL-删除配方 */
  REMOVE_BOM: "/bom/removeBom.action",
  /** URL-删除原材料 */
  REMOVE_BOM_DETAIL: "/bom/removeBomDetail.action",
  /** URL-采用为默认配方 */
  SET_DEFAULT_BOM: "/bom/setDefaultBom.action",

  //kitchen
  /** URL-搜索中央厨房列表 */
  LIST_KITCHENS: "/kitchen/listKitchens.action",
  /** URL-删除中央厨房 */
  DELETE_KITCHEN: "/kitchen/deleteKitchen.action",
  /** URL-启用/停用中央厨房 */
  STOP_KITCHEN: "/kitchen/stopKitchen.action",
  /** URL-添加中央厨房 */
  ADD: "/kitchen/add.action",
  /** URL-修改中央厨房 */
  MODIFY: "/kitchen/modify.action",
  /** URL-获取中央厨房详情 */
  ACQUIRE: "/kitchen/acquire.action",

  //material
  /** URL-获取货品列表（分页） */
  LIST_MATERIAL: "/material/listMaterial.action",
  /** URL-导出货品单 */
  EXPORT_MATERIAL: "/material/exportMaterial.action",
  /** URL-获取货品详情 */
  ACQUIRE_MATERIAL_DETAIL: "/material/acquireMaterialDetail.action",
  /** URL-启用/停用物料 */
  STOP_MATERIAL: "/material/stopMaterial.action",
  /** URL-添加物料信息 */
  ADD_MATERIAL: "/material/addMaterial.action",
  /** URL-修改物料信息 */
  MODIFY_MATERIAL: "/material/modifyMaterial.action",

  //priceManage
  /** URL-分页获取采购调价单列表 */
  LIST_PURCHASE_PRICE_MANAGE_ORDER: "/priceManage/listPurchasePriceManageOrder.action",
  /** URL-添加采购调价单 */
  ADD_PURCHASE_PRICE_MANAGE: "/priceManage/addPurchasePriceManage.action",
  /** URL-获取采购调价单详情 */
  ACQUIRE_PURCHASE_PRICE_MANAGE_INFO: "/priceManage/acquirePurchasePriceManageInfo.action",
  /** URL-作废采购调价单详情 */
  CANCEL_PURCHASE_PRICE_MANAGE: "/priceManage/cancelPurchasePriceManage.action",
  /** URL-分页获取成本调价单列表 */
  LIST_PRODUCE_PRICE_MANAGE_ORDER: "/priceManage/listProducePriceManageOrder.action",
  /** URL-添加成本调价单 */
  ADD_PRODUCE_PRICE_MANAGE: "/priceManage/addProducePriceManage.action",
  /** URL-获取成本调价单详情 */
  ACQUIRE_PRODUCE_PRICE_MANAGE_INFO: "/priceManage/acquireProducePriceManageInfo.action",
  /** URL-获取配送中心下所有产成品 */
  LIST_PRODUCE_MATERIAL_PRICE_MANAGE: "/priceManage/listProduceMaterial.action",
  /** URL-分页获取调拨调价单列表 */
  LIST_ALLOT_PRICE_MANAGE_ORDER: "/priceManage/listAllotPriceManageOrder.action",
  /** URL-添加调拨调价单 */
  ADD_ALLOT_PRICE_MANAGE: "/priceManage/addAllotPriceManage.action",
  /** URL-获取调拨调价单详情 */
  ACQUIRE_ALLOT_PRICE_MANAGE_INFO: "/priceManage/acquireAllotPriceManageInfo.action",
  /** URL-获取调拨货品 */
  LIST_ALLOT_MATERIAL_PRICE_MANAGE: "/priceManage/listAllotMaterial.action",
  /** URL-作废调拨调价单 */
  CANCEL_ALLOT_PRICE_MANAGE: "/priceManage/cancelAllotPriceManage.action",
  /** URL-根据门店和配送中心搜索货品 */
  SEARCH_REQUIRE_MATERIALS: "/priceManage/searchRequireMaterials.action",
  /** URL-分页获取要货调价单列表 */
  LIST_REQUIRE_PRICE_MANAGE: "/priceManage/listRequirePriceManage.action",
  /** URL-添加要货调价单 */
  ADD_REQUIRE_PRICE_MANAGE: "/priceManage/addRequirePriceManage.action",
  /** URL-获取要货调价单详情 */
  ACQUIRE_REQUIRE_PRICE_MANAGE: "/priceManage/acquireRequirePriceManage.action",
  /** URL-作废要货调价单 */
  CANCEL_REQUIRE_PRICE_MANAGE: "/priceManage/cancelRequirePriceManage.action",

  //supplier
  /** URL-获取供应商列表 */
  LIST_SUPPLIERS: "/supplier/listSuppliers.action",
  /** URL-启用/停用供应商 */
  STOP: "/supplier/stop.action",
  /** URL-添加供应商 */
  ADD_SUPPLIERS: "/supplier/add.action",
  /** URL-修改供应商 */
  MODIFY_SUPPLIER: "/supplier/modify.action",
  /** URL-获取供应商详情 */
  ACQUIRE_SUPPLIER: "/supplier/acquire.action",
  /** URL-添加货品 */
  ADD_MATERIAL_SUPPLIER: "/supplier/addMaterial.action",
  /** URL-删除货品 */
  DELETE_MATERIAL_SUPPLIER: "/supplier/deleteMaterial.action",
  /** URL-导出采购价 */
  EXPORT_MATERIAL_SUPPLIER: "/supplier/exportMaterial.action",

  //staff
  /** URL-添加员工 */
  ADD_STAFF: "/staff/add.action",
  /** URL-修改员工 */
  MODIFY_STAFF: "/staff/modify.action",
  /** URL-分页获取货品列表 */
  LIST_STAFF: "/staff/listStaff.action",
  /** URL-获取员工详情 */
  ACQUIRE_STAFF: "/staff/acquire.action",
  /** URL-启用/停用员工 */
  STOP_STAFF: "/staff/stop.action",
  /** URL-保存角色 */
  ADD_ROLE_STAFF: "/staff/addRole.action",
  /** URL-保存所属角色 */
  ADD_MODULE: "/staff/addModule.action",
  /** URL-重置员工密码 */
  RESET_PASSWORD: "/staff/resetPassword.action",

  //role
  /** URL- 获取所有角色 */
  LIST_ROLE: "/role/listRole.action",
  /** URL-获取角色各个模块下的权限数目 */
  ACQUIRE_ROLE: "/role/acquireRole.action",
  /** URL-添加角色 */
  ADD_ROLE: "/role/add.action",
  /** URL-修改角色 */
  MODIFY_ROLE: "/role/modify.action",
  /** URL-删除角色 */
  DELETE_ROLE: "/role/delete.action",
  /** URL-获取各个模块的系统权限 */
  LIST_MODULE_PERMS: "/role/listModulePerms.action",
  /** URL-获取角色下的权限 */
  LIST_ROLE_PERMS: "/role/listRolePerms.action",
  /** URL-保存权限 */
  SAVE_ROLE_PERMS: "/role/saveRolePerms.action",

  //printTemplate
  /** URL-添加打印模板 */
  ADD_PRINT: "/printTemplate/add.action",
  /** URL-删除打印模板 */
  DELETE_PRINT: "/printTemplate/delete.action",
  /** URL-修改打印模板 */
  MODIFY_PRINT: "/printTemplate/modify.action",
  /** URL-获取打印模板列表 */
  LIST_PRINT: "/printTemplate/list.action",

  //merchant
  /** URL-分页获取户列表 */
  PAGE_BY_FUZZY: "/merchant/pageByFuzzy.action",
  /** URL-添加商户 */
  ADD_MERCHANT: "/merchant/add.action",
  /** URL-修改商户 */
  MODIFY_MERCHANT: "/merchant/modify.action",
  /** URL-启用/停用商户 */
  STOP_MERCHANT: "/merchant/stop.action",
  /** URL-获取商户详情 */
  ACQUIRE_MERCHANT: "/merchant/acquire.action",
  /** URL-获取商户详情 */
  LIST_SHOP_MERCHANT: "/merchant/listShop.action",
  /** URL-添加门店 */
  ADD_SHOP_MERCHANT: "/merchant/addShop.action",
  /** URL-删除门店 */
  DELETE_SHOP_MERCHANT: "/merchant/deleteShop.action",

  //brand
  /** URL-获取品牌列表 */
  LIST: "/brand/list.action",
  /** URL-添加品牌 */
  ADD_BRAND: "/brand/add.action",
  /** URL-修改品牌 */
  MODIFY_BRAND: "/brand/modify.action",
  /** URL-获取配送价系数修改记录 */
  LIST_LOG: "/brand/listLog.action",

}

export default url;



// WEBPACK FOOTER //
// ./src/assets/ajax/conf.js